"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connector = void 0;
const DEFAULT_REQUEST_HEADERS_1 = require("../constants/DEFAULT_REQUEST_HEADERS");
const api_json_response_1 = require("../utils/api.json.response");
const use_fetch_helper_1 = require("../helpers/use-fetch.helper");
const api_blob_response_1 = require("../utils/api.blob.response");
const EXCEL_DOWNLOAD_REQUEST_HEADERS_1 = require("../constants/EXCEL_DOWNLOAD_REQUEST_HEADERS");
class Connector {
    /**
     * @constructor
     *
     * @param config
     * @param authManager
     * @param _verbose
     */
    constructor(config, authManager, _verbose, _logger) {
        this.config = config;
        this.authManager = authManager;
        this._verbose = _verbose;
        this._logger = _logger;
    }
    /**
     * @description
     * Raw fetch request to CiPortal API endpoint
     *
     * @todo needs to be refactored to apiFetchJson, as JSON is assumed
     *
     * @param url
     * @param method
     * @param opts
     */
    apiFetch(url, method, 
    // eslint-disable-next-line @typescript-eslint/ban-types
    opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const useUrl = this.config.urlWithVersion(url, opts === null || opts === void 0 ? void 0 : opts.apiVersion);
            let body = undefined;
            const signal = opts === null || opts === void 0 ? void 0 : opts.signal;
            const headers = Object.assign(Object.assign({}, DEFAULT_REQUEST_HEADERS_1.DEFAULT_REQUEST_HEADERS), opts === null || opts === void 0 ? void 0 : opts.headers);
            if (opts === null || opts === void 0 ? void 0 : opts.body)
                body = JSON.stringify(opts.body);
            const init = {
                method,
                signal,
                headers,
                body,
            };
            const response = yield use_fetch_helper_1.useFetch(useUrl, init);
            // reset auth manager
            if (response.status === 401) {
                yield this.authManager.reset();
            }
            try {
                const json = yield response.json();
                return new api_json_response_1.ApiJsonResponse(response, json);
            }
            catch (error) {
                // If the json could not be parsed (i.e. because the response was a 204 - no data) return a no-body JSONResponse
                if (error instanceof SyntaxError) {
                    // TODO: this won't fly with most response wrappers
                    return new api_json_response_1.ApiJsonResponse(response, {});
                }
                throw error;
            }
        });
    }
    /**
     * @description
     * Raw fetch request to CiPortal API endpoint
     *
     * @param url
     * @param method
     * @param opts
     */
    apiFetchBlob(url, method, 
    // eslint-disable-next-line @typescript-eslint/ban-types
    opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const useUrl = this.config.urlWithVersion(url, opts === null || opts === void 0 ? void 0 : opts.apiVersion);
            let body = undefined;
            const signal = opts === null || opts === void 0 ? void 0 : opts.signal;
            const headers = Object.assign(Object.assign({}, EXCEL_DOWNLOAD_REQUEST_HEADERS_1.EXCEL_DOWNLOAD_REQUEST_HEADERS), opts === null || opts === void 0 ? void 0 : opts.headers);
            if (opts === null || opts === void 0 ? void 0 : opts.body)
                body = JSON.stringify(opts.body);
            const init = {
                method,
                signal,
                headers,
                body,
            };
            const response = yield use_fetch_helper_1.useFetch(useUrl, init);
            // reset auth manager
            if (response.status === 401) {
                yield this.authManager.reset();
            }
            try {
                const blob = yield response.blob();
                return new api_blob_response_1.ApiBlobResponse(response, blob);
            }
            catch (error) {
                // If the blob could not be parsed (i.e. because the response was a 204 - no data) return a no-body JSON Response
                if (error instanceof SyntaxError) {
                    // TODO: this won't fly with most response wrappers
                    return new api_blob_response_1.ApiBlobResponse(response, null);
                }
                throw error;
            }
        });
    }
    /**
     * @description
     * Fetch from a CiPortal API endpoint With authentication
     *
     * @todo this may also need to be refactored to accomodate non JSON types
     *
     * @param url
     * @param method
     * @param opts
     */
    apiFetchWithAuth(url, method, 
    // eslint-disable-next-line @typescript-eslint/ban-types
    opts) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (this._verbose)
                (_b = (_a = this._logger) === null || _a === void 0 ? void 0 : _a.debug) === null || _b === void 0 ? void 0 : _b.call(_a, `[Connector] ${method.toUpperCase()} ${url}`);
            // @note this now will lead to a throw when authManager doesn't store username and password...
            // get credentials, auto-resetting the auth manager if it's failed
            if (this.authManager.isFailed()) {
                yield this.authManager.reset();
            }
            const credentials = yield this.authManager.credentials();
            const headers = Object.assign({ 'Authorization': `Bearer ${credentials.access_token}` }, opts === null || opts === void 0 ? void 0 : opts.headers);
            // simply add auth headers to a regular fetch
            const result = yield this.apiFetch(url, method, Object.assign(Object.assign({}, opts), { headers }));
            return result;
        });
    }
    /**
     * @description
     * Fetch from a CiPortal API endpoint With authentication
     *
     * @param url
     * @param method
     * @param opts
     */
    apiFetchBlobWithAuth(url, method, 
    // eslint-disable-next-line @typescript-eslint/ban-types
    opts) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (this._verbose)
                (_b = (_a = this._logger) === null || _a === void 0 ? void 0 : _a.debug) === null || _b === void 0 ? void 0 : _b.call(_a, `[Connector] ${method.toUpperCase()} ${url}`);
            // @note this now will lead to a throw when authManager doesn't store username and password...
            // get credentials, auto-resetting the auth manager if it's failed
            if (this.authManager.isFailed()) {
                yield this.authManager.reset();
            }
            const credentials = yield this.authManager.credentials();
            const headers = Object.assign({ 'Authorization': `Bearer ${credentials.access_token}` }, opts === null || opts === void 0 ? void 0 : opts.headers);
            // simply add auth headers to a regular fetch
            const result = yield this.apiFetchBlob(url, method, Object.assign(Object.assign({}, opts), { headers }));
            return result;
        });
    }
}
exports.Connector = Connector;
